// Small presentational chart-wrapper components extracted from Progress.jsx.
// - ChartCard: white rounded card + Samsung "Smart Select" long-press guard.
// - AxisHint: tiny caption under a chart's x-axis (used in year view).
// - Legend: coloured-dot legend row.

export function ChartCard({ title, subtitle, children, testid }) {
  // Suppress Samsung One UI's "Smart Select" / Google's "Circle to Search"
  // overlay that mistakes SVG bars for images on long-press and paints a
  // heavy black selection rectangle. We block the trigger events at the
  // React layer so the OS never gets a chance to react.
  const kill = (e) => { e.preventDefault(); e.stopPropagation(); };
  return (
    <section
      className="bg-white rounded-3xl p-5 shadow-card select-none"
      data-testid={testid}
      dir="rtl"
      onContextMenu={kill}
      onDragStart={kill}
      style={{
        WebkitUserSelect: "none",
        WebkitTouchCallout: "none",
        WebkitUserDrag: "none",
        userSelect: "none",
        touchAction: "manipulation",
      }}
    >
      <div className="text-right mb-3">
        <h3 className="font-bold text-neutral-900">
          {title} {subtitle && <span className="text-xs text-neutral-500 font-normal">{subtitle}</span>}
        </h3>
      </div>
      {children}
    </section>
  );
}

// Small hint under the chart's X axis explaining what the numeric labels represent
export function AxisHint({ viewMode }) {
  const label = viewMode === "year" ? "الأرقام تمثّل أشهر السنة" : "";
  if (!label) return null;
  return <div className="text-[10px] text-neutral-400 text-center mt-1" dir="rtl">{label}</div>;
}

export function Legend({ items }) {
  return (
    <div className="flex justify-center gap-3 mt-2 flex-wrap" dir="rtl">
      {items.map((it) => (
        <div key={it.l} className="flex items-center gap-1.5 text-xs text-neutral-600">
          <span className="w-2.5 h-2.5 rounded-full" style={{ background: it.c }} />
          {it.l}
        </div>
      ))}
    </div>
  );
}
